import $ from 'jquery';

var immagine_grande = document.getElementsByClassName('parallax-img-grande');
new simpleParallax(immagine_grande, {
	overflow: false
});

var immagine_piccola = document.getElementsByClassName('parallax-img-piccola');
new simpleParallax(immagine_piccola, {
	overflow: true
});

var immagine_laterale = document.getElementsByClassName('parallax-img-laterale');
new simpleParallax(immagine_laterale, {
	overflow: false
});


// WEBPACK FOOTER //
// ../views/blocks/titolo-testo-bottone-immagine-due/titolo-testo-bottone-immagine-due.js